import { responsiveFontSizes } from '@material-ui/core';
import presets from './presets';

const getTheme = (preset: string) => {
  const theme = presets[preset];
  return responsiveFontSizes(theme);
};

export default getTheme;
